import ludumFeatureMixin from './features';
import { ROUTES_CREATE_SESSION, ROUTES_CREATE_EVENT } from '@/constants/routes';
import { mapGetters } from 'vuex';

export default {
    mixins: [ludumFeatureMixin],

    data() {
        return {
            loading: false,
            error: null
        };
    },

    destroyed() {
        // avoid memory leaks https://vuejs.org/v2/cookbook/avoiding-memory-leaks.html#Introduction
        if (this.$data) {
            Object.keys(this.$data).forEach(key => {
                this.$data[key] = null;
                this.$delete(this.$data, key);
            });
        }
    },

    methods: {
        beforeRequest() {
            this.loading = true;
            this.error = null;
        },

        openEditSession(id, tabIndex = 0, isEvent = false) {
            const state = isEvent ? ROUTES_CREATE_EVENT : ROUTES_CREATE_SESSION;
            this.$router
                .push({
                    name: state,
                    params: {
                        id: id,
                        tabIndex: tabIndex
                    }
                })
                .catch(() => {});
        },

        squadGroupTranslation(count = 1) {
            const label = this.isClubDefaultSportWater ? 'squad' : 'group';
            return this.$tc(label, count);
        }
    },

    computed: {
        ...mapGetters(['isClubDefaultSportWater'])
    },

    filters: {
        formatDateTime(value, format) {
            return !value ? '-' : moment(value).format(format);
        },

        formatDecimal(value, digits = 2) {
            return !value ? 0 : value.toFixed(digits);
        }
    }
};
